import { PlaceData, Place } from '../types/Place'

export const handleInitialPlaceDate = (data: PlaceData): Place => {
  return {
    id: data.id.S,
    name: data.place_name.S,
    category: data.category_name.S,
    distance: Number(data.distance.N),
    placeUrl: data.place_url.S,
    searchedAt: data.searched_at.S,
    x: data.x.S,
    y: data.y.S,
  }
}
